import Axios from 'core/axios';

const state = {
  user: null,
  checked: null,
  token: window.localStorage.getItem('token'),
};

const getters = {
  authenticated: ({ user }) => user !== null,
  hasBalance: ({ user }) => user.balance > 0,
  balance: ({ user }) => user.balance,
  root: ({ user }) => !! user.root,
};

const mutations = {
  'SET_USER' (state, user) {
    state.user = user;
  },

  'SET_TOKEN' (state, token) {
    state.token = token;
    state.checked = null;
  },

  'SET_CHECKED' (state, flag) {
    state.checked = flag;
  },
};

const actions = {
  check ({ commit, state }) {
    if (! state.token || state.checked === false) {
      return Promise.reject();
    }

    if (state.checked === true) {
      return Promise.resolve();
    }

    Axios.defaults.headers.common['Authorization'] = 'bearer ' + state.token;

    return new Promise((resolve, reject) => {
      Axios.get('auth/me')
        .then(({ data }) => {
          commit('SET_USER', data);
          commit('SET_CHECKED', true);

          resolve(data);
        })
        .catch(() => {
          commit('SET_CHECKED', false);

          reject();
        });
    });
  },

  logout () {
    return new Promise((resolve, reject) => {
      Axios.post('auth/logout')
        .catch(() => {})
        .then(() => localStorage.setItem('token', null))
        .then(resolve);
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/stores/auth.js